import { Config } from "../config";
import { api } from "./apiService";

export const get_all_industries = () => {
  try {
    return new Promise((resolve) => {
      api
        .get(Config.app_api_url + "/industries", {})
        .then((data) => {
          resolve(data);
        })
        .catch(resolve);
    });
  } catch (error) {
    console.log(error);
  }
};

export const get_companies_by_industry_id = (id) => {
  try {
    return new Promise((resolve) => {
      api
        .get(Config.app_api_url + "/companies/" + id)
        .then((data) => {
          console.log("data:-", data);
        })
        .catch(resolve);
    });
  } catch (error) {
    console.log(error);
  }
};

export const get_offers_by_company_id = (pageNo = 1, industry_id, search = null, perPage = 8) => {
  try {
    return new Promise((resolve) => {
      let query = `?page=${pageNo}${industry_id != undefined ? "&industry_id=" + industry_id : ""}${
        search ? "&search=" + search : ""
      }&per_page=${perPage}`;
      api
        .get(`${Config.app_api_url}/offers/${getHashedQuery(query)}${query}`)
        .then((data) => {
          resolve(data);
        })
        .catch(resolve);
    });
  } catch (error) {
    console.log(error);
  }
};

export const get_brochures_by_offer_id = (id) => {
  try {
    return new Promise((resolve) => {
      api
        .get(Config.app_api_url + "/brochures/" + id)
        .then((data) => {
          resolve(data);
        })
        .catch(resolve);
    });
  } catch (error) {
    console.log(error);
  }
};

// Tracking API

export const post_user_tracking = (
  type,
  objectId,
  eventType,
  location,
  brochure_number,
  UUID,
  resource,
  out_page_url,
  screenId,
  track_UUID,
  duration,
  related_track_UUID
) => {
  try {
    let object_key = objectId.object ? "object" : "objectId";

    return new Promise((resolve) => {
      let body = {
        type,
        [object_key]: objectId?.object ? objectId.object : objectId,
        eventType,
        latitude: location?.location?.lat,
        longitude: location?.location?.lon,
        brochure_number,
        UUID,
        resource,
        out_page_url,
        screenId,
        track_UUID,
        duration,
        related_track_UUID,
      };
      api.post(Config.app_api_url + "/brochure-tracking", body).then((data) => {
        resolve(data);
      });
    });
  } catch (error) {}
};

// Location API

export const get_location_by_ip = () => {
  try {
    return new Promise((resolve) => {
      api
        .get(Config.app_api_url + "/getLocationByIp")
        .then((data) => {
          resolve(data);
        })
        .catch(resolve);
    });
  } catch (error) {
    console.log(error);
  }
};

export const getHashedQuery = (query) => {
  let h = 0;
  for (let i = 0; i < query.length; i++) {
    h = +Math.imul(31, h) + query.charCodeAt(i) || 0;
  }
  return Math.abs(h);
};
